/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Line_HeightInputs */

const en_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Line Height`)
};

const es_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura de línea`)
};

const fr_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauteur de ligne`)
};

const de_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeilenhöhe`)
};

const ja_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行の高さ`)
};

const zh_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`行高`)
};

const ar_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ارتفاع السطر`)
};

const id_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinggi Baris`)
};

const it_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altezza Linea`)
};

const ru_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Межстрочный интервал`)
};

const pt_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Altura da Linha`)
};

const ko_line_height = /** @type {(inputs: Line_HeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`줄 간격`)
};

/**
* | output |
* | --- |
* | "Line Height" |
*
* @param {Line_HeightInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const line_height = /** @type {((inputs?: Line_HeightInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Line_HeightInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_line_height(inputs)
	if (locale === "es") return es_line_height(inputs)
	if (locale === "fr") return fr_line_height(inputs)
	if (locale === "de") return de_line_height(inputs)
	if (locale === "ja") return ja_line_height(inputs)
	if (locale === "zh") return zh_line_height(inputs)
	if (locale === "ar") return ar_line_height(inputs)
	if (locale === "id") return id_line_height(inputs)
	if (locale === "it") return it_line_height(inputs)
	if (locale === "ru") return ru_line_height(inputs)
	if (locale === "pt") return pt_line_height(inputs)
	return ko_line_height(inputs)
});